@if (config(); as config) {
  @if (config.dataType === 'boolean') {
    <pr-edit-report-filter-boolean
      class="flex grow"
      [filter]="filter()"
      (filterChange)="filterChange.emit($event)"
    />
  } @else if (config.optionResolver) {
    <pr-edit-report-filter-select
      class="flex grow"
      [dataSource]="dataSource()"
      [filter]="filter()"
      (filterChange)="filterChange.emit($event)"
    />
  } @else {
    @switch (config.dataType) {
      @case ('none') {
        <div class="text-xs opacity-50">No Filter Available</div>
      }
      @case ('string') {
        <pr-edit-report-filter-string
          class="flex grow"
          [dataSource]="dataSource()"
          [filter]="filter()"
          (filterChange)="filterChange.emit($event)"
        />
      }
      @case ('number') {
        <pr-edit-report-filter-number
          class="flex grow"
          [dataSource]="dataSource()"
          [filter]="filter()"
          (filterChange)="filterChange.emit($event)"
        />
      }
      @case ('date') {
        <pr-edit-report-filter-date
          class="flex grow"
          [dataSource]="dataSource()"
          [filter]="filter()"
          (filterChange)="filterChange.emit($event)"
        />
      }
    }
  }
}
